import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { getUserRoles, addCountriy } from "network/service";
import Autocomplete from "@mui/material/Autocomplete";

export default function AddCountry(props) {
    const [newField, setNewField] = useState({ name: "", description: "", code: '' });
    const [errors, setErrors] = useState({});
    const { showNotification } = useNotification();
    const [roles, setRoles] = useState([]);
    const [selRole, setSelRole] = useState(null);
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let isValid = true;
        let newErrors = {};

        if (newField.name.trim() === "") {
            newErrors = { ...newErrors, name: "Name is required" };
            isValid = false;
        }
        if (newField.description.trim() === "") {
            newErrors = { ...newErrors, description: "Description is required" };
            isValid = false;
        }
        if (newField.code.trim() === "") {
            newErrors = { ...newErrors, description: "Code is required" };
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    }

    const submit = async () => {
        try {
            const isValid = validate();

            if (isValid) {
                setLoading(true);
                if (props.details && props.details._id) {
                    console.log("Updating Branch with id:", props.details._id);
                    // showNotification("success", "Success", "Updated the Branch Details successfully");
                    props.handlesuccess();
                } else {
                    console.log("Adding new Branch");
                    await addCountriy({ name: newField.name, description: newField.description, code: newField.code });
                    showNotification("success", "Success", "Added the Country Details successfully");
                    props.handlesuccess();
                }
                setLoading(false);
                props.handleclose();
            }
        } catch (err) {
            console.error("Error Country Details:", err);
            setLoading(false);
            showNotification("error", "Error", "Failed to add Country.");
        }
    };

    useEffect(() => {
        console.log("props.details:", props.details);
        if (props.details) {
            console.log("Setting newField with props.details:", props.details);

        }
    }, [props.details]);



    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            maxHeight="90%"
            onClose={props.handleclose}
            disableBackdropClick
        >
            <div>
                <DialogTitle>{props.details ? 'Edit Country' : 'Add Country'}</DialogTitle>
            </div>
            <DialogContent sx={{ minWidth: 500 }}>
                <Grid container direction="column" spacing={2}>
                    <Grid item >
                        <MDInput
                            label="Name"
                            value={newField.name}
                            disabled={props.details}
                            fullWidth
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    name: e.target.value
                                });
                            }}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.name}</FormHelperText>}
                        // helperText={
                        //     <FormHelperText sx={{ color: '#FF0000', fontWeight: 800, margin: 0 }}>
                        //         {errors.name && "Customer Name is required"}
                        //     </FormHelperText>
                        // }
                        />

                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            disabled={props.details}
                            label="Description"
                            value={newField.password}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.description}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    description: e.target.value
                                });
                            }}
                        />
                    </Grid>
                    <Grid item>
                        <MDInput
                            fullWidth
                            disabled={props.details}
                            label="Code"
                            value={newField.password}
                            helperText={<FormHelperText sx={{ color: 'red', fontWeight: 800, margin: 0 }}>{errors.code}</FormHelperText>}
                            onChange={(e) => {
                                setNewField({
                                    ...newField,
                                    code: e.target.value
                                });
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <MDButton variant="gradient" color="error" onClick={props.handleclose}>
                    <Icon>close</Icon>&nbsp;
                    Cancel
                </MDButton>
                <MDButton variant="gradient" color="success" onClick={submit}>
                    <Icon>save</Icon>&nbsp;
                    Save
                </MDButton>

            </DialogActions>
        </Dialog>
    )
}
